import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!

  return (_ctx.isQRCode)
    ? (_openBlock(), _createBlock(_component_qrcode_vue, {
        key: 0,
        value: _ctx.getQRCode,
        size: 200
      }, null, 8, ["value"]))
    : (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: _ctx.uri,
        class: "img-fluid",
        alt: "..."
      }, null, 8, _hoisted_1))
}